import { useProductsQuery } from "../../../../saleor/api";
import {
  handleFilterProductAttributes,
  mapEdgesToNodes,
} from "../../../../base/utils";
import { ProductTransformer } from "../../../../services/objectTransformer/products";
import { useSelector } from "react-redux";
import { Note } from "../../../../helbest";
import { channelDetails } from "../../../../base/env";

export default function useProducts({
  cat,
  sort,
  init,
  sales,
  ...queryParams
}) {
  const attributes = useSelector((state) => state.Attributes);

  const { channel } = useSelector((state) => state.Login);

  const {
    data: productsData,
    refetch,
    loading,
  } = useProductsQuery({
    variables: {
      channel: channel,
      filter: {
        ...(cat && {
          categories:
            cat.split(",").at(-1) === "sales" ? [] : [cat.split(",").at(-1)],
        }),
        attributes: handleFilterProductAttributes(
          {
            ...queryParams,
            ...(cat.split(",").at(-1) === "sales" && { sales: "sales" }),          },
          [...attributes, "sales"],
        ),
      },
      ...(sort
        ? {
            sortBy: {
              field: sort.split("-")[0],
              direction: sort.split("-")[1],
            },
          }
        : init
          ? {
              sortBy: {
                attributeId: init,
                direction: "DESC",
              },
            }
          : {}),
      first: 100,
    },
    onError: (error) => {
      Note.error(error.message);
    },
  });

  return {
    products: mapEdgesToNodes(
      productsData?.products?.edges,
      ProductTransformer,
    ),
    refetch,
    loading,
  };
}
